module.exports = __webpack_public_path__ + "img/background-image-1.6baf7037.png";